export interface PackageSectionData {
  packageSectionTitle: string;
  packageSectionSubtitle: string;
  packages: Package[];
}

export interface Package {
  title: string;
  description: string;
  price?: string;
  priceType?: string;
  priceFrequency?: string;
  items: PackageItem[];
  interactionModes: InteractionMode[];
  otherFeatures?: OtherFeature[];
  customText?: string;
  buttonText: string;
}

export interface PackageItem {
  name?: string;
  value?: string;
}

export interface InteractionMode {
  name?: string;
  value?: string;
}


export interface OtherFeature {
  value?: string;
}

export interface PackageProperty {
  type: PackagePropertyType;
  inputType?: PackageInputType;
  inputLayout?: PackageInputLayout;
  key: string;
  title: string;
  description?: string;
  label?: string;
  items: PackagePropertyValue[];
}

export enum PackagePropertyType {
  Single = 'single',
  Multiple = 'multiple'
}

export enum PackageInputType {
  Select = 'select',
  Checkbox = 'checkbox',
  Radio = 'radio'
}

export enum PackageInputLayout {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export interface PackagePropertyValue {
  name: string;
  value: string;
  description?: string;
}
